import { render, staticRenderFns } from "./AudioPitch.vue?vue&type=template&id=82e34cf6"
import script from "./AudioPitch.vue?vue&type=script&lang=js"
export * from "./AudioPitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports